import { IAddFaqPayload, IAddEditPolicyPayload } from '@/types/payload';
import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const fetchFAQs = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/admin/faq${queryString ? `?${queryString}` : ''}`),
    false
  );
};

export const addFAQ = async (payload: IAddFaqPayload) => {
  return serviceHelper(http.post('/admin/faq', payload), false);
};

export const updateFAQ = async (id: string, payload: IAddFaqPayload) => {
  return serviceHelper(http.patch(`/admin/faq/${id}`, payload), false);
};

export const deleteFAQ = async (payload: { faq_id: string }) => {
  return serviceHelper(http.delete('/admin/faq', { data: payload }), false);
};

export const getFAQById = async (id: string) => {
  return serviceHelper(http.get(`/admin/faq/${id}`), false);
};

export const fetchPolicies = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/admin/policy${queryString ? `?${queryString}` : ''}`),
    false
  );
};

export const getPolicyById = async (id: string) => {
  return serviceHelper(http.get(`/admin/policy/${id}`), false);
};

export const addPolicy = async (payload: IAddEditPolicyPayload) => {
  return serviceHelper(http.post('/admin/policy', payload), false);
};

export const updatePolicy = async (
  id: string,
  payload: IAddEditPolicyPayload
) => {
  return serviceHelper(http.patch(`/admin/policy/${id}`, payload), false);
};

export const deletePolicy = async (payload: { policy_id: string }) => {
  return serviceHelper(http.delete('/admin/policy', { data: payload }), false);
};
